export default function Hero() {
  return (
    <section id="top" className="mx-auto max-w-7xl px-4 pt-10 pb-12 md:px-6 md:pt-14 md:pb-16">
      <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-12 lg:gap-12">
        {/* text column */}
        <div className="lg:col-span-6">
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-red-700 px-3 py-1 text-xs font-medium text-[#f7f3eb]">
              <i className="ri-flashlight-fill w-4 h-4 flex items-center justify-center"></i>
              本期封面 · 独家
            </span>
            <span className="text-xs tracking-[0.22em] text-stone-400 uppercase">Vol. 268 · 吃瓜现场</span>
          </div>

          <h2 className="font-serif-sc mt-6 text-balance text-4xl leading-[1.15] font-black text-stone-900 md:text-5xl">
            事件、人物与关键词，
            <br />
            全网吃瓜一搜即得
          </h2>

          <p className="mt-6 max-w-xl text-base leading-7 text-stone-600">
            网曝网🎥关键词搜索查找功能，支持<strong className="font-semibold text-stone-800">事件查询</strong>、<strong className="font-semibold text-stone-800">人物专题</strong>与<strong className="font-semibold text-stone-800">站内查找</strong>。无论你追的是一个人、一段旧瓜还是一条正在发酵的现场，都能被快速定位——爆料不停，网曝不止。
          </p>

          {/* meta strip */}
          <div className="mt-7 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-stone-500">
            <span className="flex items-center gap-1.5">
              <i className="ri-time-line w-4 h-4 flex items-center justify-center"></i>
              昨夜更新 47 条
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-user-follow-line w-4 h-4 flex items-center justify-center"></i>
              12.8 万人正在站内查找
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-fire-fill w-4 h-4 flex items-center justify-center text-red-700"></i>
              热搜第一：曝一条
            </span>
          </div>

          {/* CTAs */}
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#search"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-red-700 px-6 py-3 text-sm font-semibold text-[#f7f3eb] transition-colors hover:bg-red-800"
            >
              开始查找
              <i className="ri-search-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-stone-300 bg-white px-6 py-3 text-sm font-semibold text-stone-700 transition-colors hover:border-red-700 hover:text-red-700"
            >
              进入现场热议
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>

          <div className="magazine-rule mt-10 h-px w-full"></div>
          <p className="mt-3 text-[11px] tracking-wide text-stone-400">
            网曝网关键词库已收录 <span className="text-red-700">860,000+</span> 条爆料线索，持续归档中
          </p>
        </div>

        {/* cover image column */}
        <div className="lg:col-span-6">
          <div className="relative mx-auto max-w-md lg:max-w-none">
            <div className="absolute -left-4 -top-4 hidden h-24 w-24 rounded-md border border-red-700/30 md:block"></div>
            <div className="relative overflow-hidden rounded-lg paper-card">
              <img
                src="https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20photography%2C%20a%20silhouetted%20entertainment%20reporter%20holding%20a%20microphone%20backstage%20of%20a%20gala%2C%20warm%20crimson%20and%20amber%20spotlights%20behind%2C%20dramatic%20rim%20lighting%2C%20cinematic%20film%20grain%2C%20deep%20shadows%2C%20rich%20editorial%20tone%2C%20luxurious%20event%20atmosphere%2C%20magazine%20spread%20aesthetic&width=900&height=1200&seq=cover-main-01&orientation=portrait"
                alt="网曝网本期封面 吃瓜现场报道"
                title="网曝网关键词 事件现场封面"
                className="h-[380px] w-full object-cover object-top md:h-[560px]"
              />
              <span className="absolute left-3 top-3 rounded-sm bg-[#f7f3eb]/92 px-2 py-1 text-[11px] font-semibold tracking-wide text-stone-700">
                # 现场直击
              </span>
            </div>

            {/* floating caption card */}
            <div className="paper-card absolute -bottom-5 right-0 max-w-[260px] rounded-md px-4 py-3 shadow-none md:right-6">
              <p className="font-serif-sc text-base font-bold text-stone-900">
                当红话题正在升温
              </p>
              <p className="mt-1 text-xs leading-5 text-stone-500">
                站内查找热度 +312%，评论区一夜新增 2 万条讨论
              </p>
              <a href="#hot" className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-red-700 hover:text-red-800">
                查看热议
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}